import { OverlayModule } from '@angular/cdk/overlay';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ExpandedPanelComponent } from './expanded-panel.component';

@NgModule({
  declarations: [ExpandedPanelComponent],
  exports: [ExpandedPanelComponent],
  imports: [BrowserModule, MatIconModule, OverlayModule, BrowserAnimationsModule],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ExpandedPanelModule {}
